import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import { restApiUrl } from 'appConstants';
import { WorkflowType } from 'appConstants';
import { SpecialDateRequest } from 'appTypes';
import { getCSRFCookie } from 'axios_middleware';

export const getUniqueDatesFromSpecialDates = (reqs: SpecialDateRequest[]) =>
  reqs.reduce((set, req) => {
    req.dates.forEach((d) => set.add(d));
    return set;
  }, new Set<string>());

export const getUniqueDateMonthPairs = (reqs: SpecialDateRequest[]) =>
  reqs.reduce((set, req) => {
    req.dates.forEach((d) => set.add(`${d}:${req.comparison_month}`));
    return set;
  }, new Set<string>());

export const getUsedQuotaFromRequests = (reqs?: SpecialDateRequest[]) => {
  return reqs ? getUniqueDateMonthPairs(reqs).size : 0;
};
export const baseQuery = fetchBaseQuery({
  baseUrl: restApiUrl,
  prepareHeaders: (headers) => {
    headers.append('X-CSRFToken', getCSRFCookie());
  },
});

export function isProjectIdWellFormed(id: string): boolean {
  return id.length > 2 && id !== '__proto__' && !id.startsWith('_');
}

export function isWorkflowRecognizable(workflowId: string): boolean {
  return Object.values(WorkflowType).includes(workflowId);
}
